import settingsEnums from './settings'

export default {
	[settingsEnums.SETTING_SKIN_DEFAULT]: 'Himalaya',
	[settingsEnums.SETTING_SKIN_SPACE]: 'Space',
	[settingsEnums.SETTING_SKIN_HALLOWEEN]: 'Halloween',
	[settingsEnums.SETTING_SKIN_HOLIDAY]: 'Happy Holidays!',
	[settingsEnums.SETTING_SKIN_VALENTINES]: 'Valentine’s Day',
	[settingsEnums.SETTING_SKIN_UNDERWATER]: 'Underwater',
	[settingsEnums.SETTING_SKIN_CARNIVAL]: 'Carnival',
	[settingsEnums.SETTING_SKIN_JUNGLE]: 'Jungle',
	[settingsEnums.SETTING_SKIN_SPORTS]: 'Sports',
	[settingsEnums.SETTING_SKIN_BEACH]: 'Beach',
}
